export const SubscriptionTiers = {
    candidatePremium: 'candidatePremium',
    recruiterPremium: 'recruiterPremium',
}

export const SubscriptionTiersFormatted = {
    candidatePremium: 'Candidate Premium',
    recruiterPremium: 'Recruiter Premium',
}

export const SubscriptionPrices = {
    candidatePremium: 9.99,
    recruiterPremium: 49
}